import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormHelperText,
} from "@material-ui/core";
import { useForm, Controller } from "react-hook-form";
import { useStateValue } from "../../context/store";
import { styles } from "../styles";
import * as IdKey from "short-uuid";
import { getMaestras } from "../../actions/maestras-actions";
import { experienceYears } from "./dataPostulates";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Autocomplete } from "@material-ui/lab";

const PostulatesSearch = ({ statusPostulates, professions }) => {
  const classes = styles();
  const id = IdKey.generate();

  const [{}, dispatch] = useStateValue();

  const [maestras, setMaestras] = useState({
    nivelFormacion: [],
  });
  const schema = yup.object().shape({
    personName: yup
      .string()
      .nullable()
      .trim()
      .notRequired()
      .min(3, "Ingrese mínimo 3 caracteres")
      .max(50, "Ingrese máximo 50 caracteres")
      .matches(/^(([A-Za-zÀ-ÿ])+[ ]?)*$/g, "Ingrese un nombre válido")
      .transform((v) => (v ? v : null)),
    personSurname: yup
      .string()
      .nullable()
      .trim()
      .notRequired()
      .min(3, "Ingrese mínimo 3 caracteres")
      .max(50, "Ingrese máximo 50 caracteres")
      .matches(/^(([A-Za-zÀ-ÿ])+[ ]?)*$/g, "Ingrese un apellido válido")
      .transform((v) => (v ? v : null)),
    levelEducation: yup.string().notRequired(),
    status: yup.string().notRequired(),
    professionId: yup.object().nullable().notRequired().shape({
      id: yup.string().notRequired(),
    }),
    yearsExperience: yup.string().notRequired(),
  });

  const { register, handleSubmit, setValue, control, errors } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const getListaMaestras = async () => {
    const response = await getMaestras();
    setMaestras(response.data.maestras);
    return response.data.maestras;
  };

  useEffect(() => {
    getListaMaestras();
  }, []);

  const onSubmit = (data) => {
    data.professionId = data.professionId ? data.professionId.id : null;
    if (
      data.personName !== null ||
      data.personSurname !== null ||
      data.provinceId !== null ||
      data.townId !== null ||
      data.levelEducation !== null ||
      data.status !== null ||
      data.yearsExperience !== null ||
      data.professionId !== null
    ) {
      dispatch({
        type: "SET_FILTER_POSTULATES",
        filter: data,
        isFilter: true,
      });
    }
  };

  const clearForm = () => {
    setValue("personName", "");
    setValue("personSurname", "");
    setValue("provinceId", "");
    setValue("townId", "");
    setValue("levelEducation", "");
    setValue("professionId", "");
    setValue("status", "");
    setValue("yearsExperience", "");
  };

  const clearBtn = () => {
    clearForm();
    dispatch({
      type: "SET_FILTER_POSTULATES",
      filter: {
        personName: null,
        personSurname: null,
        provinceId: null,
        townId: null,
        levelEducation: null,
        state: null,
        yearsExperience: null,
        professionId: null,
      },
      isFilter: true,
    });
  };

  return (
    <Card elevation={0} style={{ background: "#e0f2f7", marginLeft: -15 }}>
      <CardContent>
        <form
          onSubmit={handleSubmit(onSubmit)}
          className={classes.form}
          autocomplete="off"
        >
          <Grid container spacing={1}>
            <Grid item xs={12} md={6} lg={3}>
              <FormControl fullWidth>
                <TextField
                  fullWidth
                  variant="outlined"
                  inputRef={register}
                  InputLabelProps={{ shrink: true }}
                  className={classes.dropdown}
                  type="text"
                  autocomplete="off"
                  label="Primer Nombre"
                  name="personName"
                  size="small"
                  error={
                    errors.hasOwnProperty("personName") &&
                    errors["personName"].message
                  }
                />
                <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                  {errors.hasOwnProperty("personName") &&
                    errors["personName"].message}
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <FormControl fullWidth>
                <TextField
                  fullWidth
                  variant="outlined"
                  inputRef={register}
                  InputLabelProps={{ shrink: true }}
                  className={classes.dropdown}
                  type="text"
                  autocomplete="off"
                  label="Primer Apellido"
                  name="personSurname"
                  size="small"
                  error={
                    errors.hasOwnProperty("personSurname") &&
                    errors["personSurname"].message
                  }
                />
                <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                  {errors.hasOwnProperty("personSurname") &&
                    errors["personSurname"].message}
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <FormControl
                variant="outlined"
                fullWidth
                size="small"
                error={
                  !!errors.hasOwnProperty("levelEducation") &&
                  errors["levelEducation"].message
                }
              >
                <InputLabel
                  htmlFor="outlined-select-levelEducation"
                  shrink={true}
                >
                  Nivel de Formación *
                </InputLabel>
                <Controller
                  fullWidth
                  control={control}
                  inputRef={register}
                  className={classes.dropdown}
                  label="Nivel de Formación *"
                  name="levelEducation"
                  defaultValue=""
                  size="small"
                  notched={true}
                  inputProps={{
                    name: "levelEducation",
                    id: "outlined-select-levelEducation",
                  }}
                  as={
                    <Select>
                      {maestras.nivelFormacion.map((nivelFormacion) => (
                        <MenuItem
                          className={classes.menuItem}
                          key={nivelFormacion}
                          value={nivelFormacion}
                        >
                          {nivelFormacion}
                        </MenuItem>
                      ))}
                    </Select>
                  }
                />
                <FormHelperText>
                  {errors.hasOwnProperty("levelEducation") &&
                    errors["levelEducation"].message}
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <FormControl variant="outlined" fullWidth size="small">
                <InputLabel
                  htmlFor="outlined-select-status"
                  shrink={true}
                  size="small"
                >
                  Estado
                </InputLabel>
                <Controller
                  control={control}
                  inputRef={register}
                  fullWidth
                  size="small"
                  className={classes.dropdown}
                  label="Estado"
                  notched={true}
                  name="status"
                  defaultValue=""
                  inputProps={{
                    name: "status",
                    id: "outlined-select-status",
                  }}
                  as={
                    <Select>
                      {statusPostulates.map((x) => (
                        <MenuItem
                          className={classes.menuItem}
                          key={id}
                          value={x.key}
                        >
                          {x.value}
                        </MenuItem>
                      ))}
                    </Select>
                  }
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <Controller
                render={(props) => (
                  <Autocomplete
                    {...props}
                    size="small"
                    options={professions}
                    className={classes.formField}
                    getOptionLabel={(option) => option.occupation}
                    renderOption={(option) => <span>{option.occupation}</span>}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Profesión"
                        variant="outlined"
                        inputProps={{
                          ...params.inputProps,
                          style: {
                            height: "12px",
                            borderRadius: "8px",
                            paddingBottom: "6.5px",
                            fontSize: 12,
                          },
                        }}
                        error={
                          !!errors.hasOwnProperty("professionId") &&
                          errors["professionId"].message
                        }
                        helperText={
                          errors.hasOwnProperty("professionId") &&
                          errors["professionId"].message
                        }
                      />
                    )}
                    onChange={(_, data) => {
                      props.onChange(data);
                    }}
                  />
                )}
                name="professionId"
                control={control}
              />
            </Grid>
            <Grid item xs={12} md={2} lg={3}>
              <FormControl
                variant="outlined"
                fullWidth
                size="small"
                error={
                  !!errors.hasOwnProperty("yearsExperience") &&
                  errors["yearsExperience"].message
                }
              >
                <InputLabel
                  htmlFor="outlined-select-yearsExperience"
                  shrink={true}
                >
                  Años de Experiencia *
                </InputLabel>
                <Controller
                  fullWidth
                  control={control}
                  inputRef={register}
                  className={classes.dropdown}
                  label="Años de Experiencia *"
                  size="small"
                  name="yearsExperience"
                  notched={true}
                  defaultValue=""
                  inputProps={{
                    name: "yearsExperience",
                    id: "outlined-select-yearsExperience",
                  }}
                  as={
                    <Select>
                      {experienceYears.map((op) => (
                        <MenuItem
                          className={classes.menuItem}
                          aria-label="None"
                          value={op}
                        >
                          {op}
                        </MenuItem>
                      ))}
                    </Select>
                  }
                />
                <FormHelperText>
                  {errors.hasOwnProperty("yearsExperience") &&
                    errors["yearsExperience"].message}
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <Button
                variant="contained"
                className={classes.buttonSearch}
                type="submit"
              >
                Buscar
              </Button>
              &nbsp;&nbsp;
              <Button
                variant="contained"
                className={classes.buttonSearch}
                onClick={clearBtn}
              >
                Limpiar
              </Button>
            </Grid>
          </Grid>
        </form>
      </CardContent>
    </Card>
  );
};

export default PostulatesSearch;
